import { render } from "./PicScrollSlider.vue?vue&type=template&id=dc2ed152&scoped=true"
import script from "./PicScrollSlider.vue?vue&type=script&lang=js"
export * from "./PicScrollSlider.vue?vue&type=script&lang=js"

import "@/css/contact.scss?vue&type=style&index=0&id=dc2ed152&scoped=true&lang=scss"
import "./PicScrollSlider.vue?vue&type=style&index=1&id=dc2ed152&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2ed152"]])

export default __exports__